import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import WarningIcon from '@material-ui/icons/Warning'
import CustomButton from '../custom-material/button/Button'
import CustomDialog from '../custom-material/dialog/Dialog'
import CustomDialogTitle from '../custom-material/dialog/DialogTitle'
import { isEmpty } from 'lodash'

const styles = theme => ({
  dialogPaper: {
    width: 400,
    maxWidth: 400
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    letterSpacing: '0.75px'
  },
  warningIcon: {
    color: 'white',
    marginRight: 6
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16
  },
  noDrugsWarningContainer: {
    padding: 16
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: 16
  },
  yesButton: {
    width: 100,
    marginLeft: 5,
    fontSize: 14,
    fontWeight: 600
  },
  okButton: {
    width: 100,
    fontSize: 14,
    fontWeight: 600
  }
})

const NoDrugsMatchFilterDialog = ({classes, dialogOpen, handleCloseDialog, preferenceWithEmptyResults}) => (
  <CustomDialog classes={{paper: classes.dialogPaper}} open={dialogOpen && !isEmpty(preferenceWithEmptyResults)} onClose={handleCloseDialog}>
    <CustomDialogTitle className={classes.dialogTitle} id='suspend-all-dialog-title' disableTypography>
      <WarningIcon className={classes.warningIcon} /> Warning
    </CustomDialogTitle>
    <div className={classes.contentContainer}>
      <div className={classes.noDrugsWarningContainer}>
        <strong>There are no products in the IPD Database that match this request or your active subscription does not allow access to this data.</strong>
        <br /><br />
        Try adjusting the filters to broaden your search or contact us at healthcare@ipdanalytics.com to upgrade your subscription.
      </div>
      <div className={classes.actionContainer}>
        <CustomButton className={classes.okButton} onClick={handleCloseDialog} variant='contained' size='small' color='default' >Ok</CustomButton>
      </div>
    </div>
  </CustomDialog>
)

NoDrugsMatchFilterDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
  preferenceWithEmptyResults: PropTypes.object
}

export default withStyles(styles)(NoDrugsMatchFilterDialog)
